/* src/app/deal/deal.component.scss */
/*# sourceMappingURL=deal.component.css.map */
